var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"clientcabin-custom-video"},[_c('div',{staticClass:"video-container"},[_c('iframe',{attrs:{"title":"video","src":_vm.embedUrl,"allowfullscreen":"","mozallowfullscreen":"","webkitallowfullscreen":"","oallowfullscreen":"","msallowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }